import { PropTypes } from 'prop-types'

import Track from '../Track'

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

const withTracking = (event, data) => (WrappedComponent) => {
  const withTrackingHOC = (props) => {
    return (
      <Track
        data={props.trackingData || data}
        event={props.trackingEvent || event}
      >
        <WrappedComponent {...props} />
      </Track>
    )
  }
  withTrackingHOC.propTypes = {
    trackingData: PropTypes.object,
    trackingEvent: PropTypes.string,
  }
  withTrackingHOC.displayName = `withTracking(${getDisplayName(
    WrappedComponent,
  )})`

  return withTrackingHOC
}

export default withTracking
